import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { bannerService} from "@/services/api/cresivoxServer";


import {iBannerDTO, REDUCER_NAME} from "./Types";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

  export const getbannerList = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
	  rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("bannerList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
	  try {
		  const response = await bannerService.getAllBanner();
		  if (response) {
			  const {httpStatusCode, data, message} = response;

			  switch (httpStatusCode) {
				  case httpStatusCodes.SUCCESS_OK: {
					  if (data && data.data) {
						  return {
							  httpStatusCode,
							  data: data.data,
							  message,
						  };
					  } else {
						  return rejectWithValue({
							  httpStatusCode,
							  message,
						  });
					  }
				  }
				  default: {
					  return rejectWithValue({
						  httpStatusCode,
						  message,
					  });
				  }
			  }
		  } else {
			  return rejectWithValue({
				  message: "No response received",
			  });
		  }
	  } catch (error) {
		  return rejectWithValue({
			  message: "Something went wrong",
		  });
	  }
  },
);

export const getAllWholesalerBanner = createAsyncThunk<
  iGenericResponse<any | null> | null,
{wholesalerId:string},
  {
	  rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getAllWholesalerBanner"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async ({wholesalerId}, {rejectWithValue}) => {
	  try {
		  const response = await bannerService.getAllWholesalerBanner(wholesalerId);
		  if (response) {
			  const {httpStatusCode, data, message} = response;

			  switch (httpStatusCode) {
				  case httpStatusCodes.SUCCESS_OK: {
					  if (data && data.data) {
						  return {
							  httpStatusCode,
							  data: data.data,
							  message,
						  };
					  } else {
						  return rejectWithValue({
							  httpStatusCode,
							  message,
						  });
					  }
				  }
				  default: {
					  return rejectWithValue({
						  httpStatusCode,
						  message,
					  });
				  }
			  }
		  } else {
			  return rejectWithValue({
				  message: "No response received",
			  });
		  }
	  } catch (error) {
		  return rejectWithValue({
			  message: "Something went wrong",
		  });
	  }
  },
);

export const getBannerById = createAsyncThunk<
iGenericResponse<any | null> | null,
{bannerId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("getbannerById"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (arg, {rejectWithValue}) => {
	try {
		const response = await bannerService.getBannerById(arg);
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							   data:{
								banner: data.data,
								message,
							   }
							}
						
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const updatebanner = createAsyncThunk<
iGenericResponse<any | null> | null,
{bannerId:string, data: iBannerDTO },
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updatebanner"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({bannerId,data}, {rejectWithValue}) => {
	try {
		const response = await bannerService.updateBanner(bannerId,data);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const updateBannerStatus = createAsyncThunk<
iGenericResponse<any | null> | null,
{bannerId:string, status: boolean},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updatebannerStatus"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({bannerId,status}, {rejectWithValue}) => {
	try {
		const response = await bannerService.updateBannerStatus(bannerId,status);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const deletebanner = createAsyncThunk<
iGenericResponse<any | null> | null,
{bannerId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("deletebanner"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({bannerId}, {rejectWithValue}) => {
	try {
		const response = await bannerService.deleteBanner(bannerId);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
								data: data.data,
								message,
							
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


export const createbanner = createAsyncThunk<
iGenericResponse<any | null> | null,
iBannerDTO,
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("createbanner"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (payload, {rejectWithValue}) => {
	try {
		const response = await bannerService.createBanner(payload);
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_CREATED: {
					if (data && data.data) {
						return {
							data: {
								orders: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);



export const getAllWholesalerBannerWithoughtId = createAsyncThunk<
  iGenericResponse<any> | null, // ✅ Ensure return type matches expected payload
  void, // ✅ No parameter is needed
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getAllWholesalerBannerWithoughtId"),
  // @ts-expect-error
  async (_, { rejectWithValue }) => {
    try {
      const response = await bannerService.getAllWholesalerBannerWithoughtId();

      if (!response) {
        return rejectWithValue({ message: "No response received" });
      }

      const { httpStatusCode, data, message } = response;

      if (httpStatusCode === httpStatusCodes.SUCCESS_OK && data?.data) {
        return {
          httpStatusCode,
          data: data.data, // ✅ Ensure the structure matches iGenericResponse
          message,
        };
      }

      return rejectWithValue({ httpStatusCode, message });
    } catch (error) {
      console.error("🚀 ~ Error fetching wholesaler banner:", error);
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);
